import { Route } from '@angular/router';
import { LayoutComponent } from '../layouts/layouts.component';
import { AUTH_GUARD } from './auth/auth.guard';
import { RoutesValues } from '@job-v2/ats-utils';
import { ADMIN_ROLES, JOB_CONFIGURATIONS_ACCESS, JOB_OFFERS_ACCESS, JOB_TEMPLATES_ACCESS } from '@socium/common-api';
import { ForbiddenAccessComponent } from './auth/forbidden-access/forbidden-access.component';
import { DashboardRhComponent } from './dashboard/dashboard-rh/dashboard-rh.component';
import { HomeComponent } from './commons/components/home/home.component';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AUTH_GUARD],
    children: [
      {
        path: 'dashboard',
        component: DashboardRhComponent,
        canActivate: [AUTH_GUARD],
      },
      {
        path: `${RoutesValues.MODELS}`,
        loadChildren: () =>
          import('./models/models.routes').then((m) => m.modelsRoutes),
        canActivate: [AUTH_GUARD],
        data: {
          roles: ADMIN_ROLES,
          canPermission: JOB_TEMPLATES_ACCESS,
        }
      },
      {
        path: `${RoutesValues.SETTINGS}`,
        loadChildren: () =>
          import('./settings/settings.routes').then((m) => m.settingsRoutes),
        canActivate: [AUTH_GUARD],
        data: {
          roles: ADMIN_ROLES,
          canPermission: JOB_CONFIGURATIONS_ACCESS,
        }
      },
      {
        path: `${RoutesValues.MANAGEMENT}`,
        loadChildren: () =>
          import('./management/management.routes').then(
            (m) => m.ManagementRoutes,
          ),
        canActivate: [AUTH_GUARD],
        data: {
          roles: ADMIN_ROLES,
          canPermission: JOB_OFFERS_ACCESS,
        }
      },
      {
        path: 'forbidden',
        component: ForbiddenAccessComponent,
      },
    ],
  },
];
